import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal } from 'react-bootstrap';

// Elements
import LoadingSpinner from '~/elements/LoadingSpinner';
import Button from '../../components/CustomButton/CustomButton.jsx';

//components
import withLocalization from '~/hoc/withLocalization';

// Assets
import CloseModalIcon from '~/assets/img/CloseApproveModalIcon.svg';

class RecommendedHolidaysModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    componentDidMount() {
        if (this.props.isOpen) {
            this.fetchRecommendedHolidays();
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this.fetchRecommendedHolidays();
        }
    }

    fetchRecommendedHolidays = async () => {
        const { onDataFetch } = this.props;
        this.setState({ loading: true });
        try {
            if (onDataFetch) await onDataFetch();
        } catch (error) {
            console.error('Error fetching recommended holidays:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleSave = async () => {
        const { onSave } = this.props;
        this.setState({ loading: true });
        try {
            if (onSave) await onSave();
        } catch (error) {
            console.error('Error saving recommended holidays:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { isOpen, onClose, activeTab, t, recommendedHoliday } = this.props;
        const { loading } = this.state;

        return (
            <Modal show={isOpen} onHide={onClose} size="lg">
                <Modal.Header>
                    <Modal.Title className="w-100 text-center m-0">
                        {t('Recommended Holidays')}
                    </Modal.Title>
                    <img src={CloseModalIcon} alt="close button" className="cursor-pointer" onClick={onClose} />
                </Modal.Header>
                <Modal.Body style={{ minHeight: '40vh' }}>
                    {loading ? (
                        <div className="text-center">
                            <LoadingSpinner />
                        </div>
                    ) : (
                        <div>
                            {recommendedHoliday?.length > 0 ? (
                                <>
                                    <h5>
                                        {t('Save recommended holidays for year')} {activeTab}
                                    </h5>

                                    <div className="projectMemberForm">
                                        <table
                                            striped="true"
                                            bordered="true"
                                            responsive="true"
                                            className="table table-hover projectMembersFormTable"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>{t('Name')}</th>
                                                    <th>{t('Date')}</th>
                                                    <th>{t('Display Name')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {recommendedHoliday.map((holiday, index) => (
                                                    <tr key={index}>
                                                        <td>{holiday.name}</td>
                                                        <td>{holiday.date}</td>
                                                        <td>{holiday.custom_name}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            ) : (
                                <div className="text-center text-muted py-4">
                                    <div className="mb-2">
                                        <i className="fa fa-calendar-times-o fa-lg"></i>
                                    </div>
                                    <div className="small">
                                        {t('No holiday recommendations available')}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        color="primary"
                        onClick={this.handleSave}
                        disabled={loading || !recommendedHoliday?.length}
                        fill
                    >
                        {loading ? (
                            <>
                                <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            </>
                        ) : (
                            t('Save Holidays')
                        )}
                    </Button>
                    <Button color="secondary" onClick={onClose} disabled={loading}>
                        {t('Cancel')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default inject('clientStore', 'commonStore')(withLocalization(observer(RecommendedHolidaysModal)));